import moment from 'moment';
import { BulkRedeemSession, PassSessionType, TimeSlotResponseOut } from '../../../../../api';

export const DAY_KEYS = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

export const buildEventSessions = (
  orderPageId: string,
  dates: Set<string>,
  slots: Map<string, TimeSlotResponseOut[]>,
  preferredTimeByDay?: Map<number, string>,
): BulkRedeemSession[] => {
  const eventIds: string[] = [];
  Array.from(dates).forEach((date) => {
    const dateSlots = slots.get(date);
    if (!dateSlots || dateSlots.length === 0) return;

    const [firstSlot] = dateSlots as [TimeSlotResponseOut, ...TimeSlotResponseOut[]];
    let slot = firstSlot;
    if (preferredTimeByDay && dateSlots.length > 1) {
      const dayIndex = moment(date).day();
      const preferred = preferredTimeByDay.get(dayIndex);
      slot =
        (preferred && dateSlots.find((s) => moment.unix(s.seconds).utc().format('HH:mm') === preferred)) || firstSlot;
    }

    const id = slot.eventId || slot.courseId;
    if (id) eventIds.push(id);
  });
  if (eventIds.length === 0) return [];
  return [{ order_page_id: orderPageId, type: PassSessionType.EVENT, event_ids: eventIds }];
};

export const countSlots = (dates: Set<string>, slots: Map<string, TimeSlotResponseOut[]>): number => {
  let count = 0;
  dates.forEach((date) => {
    count += slots.get(date)?.length ?? 0;
  });
  return count;
};
